import { render, staticRenderFns } from "./Photograph.vue?vue&type=template&id=67c0c12d&scoped=true"
import script from "./Photograph.vue?vue&type=script&lang=js"
export * from "./Photograph.vue?vue&type=script&lang=js"
import style0 from "./Photograph.vue?vue&type=style&index=0&id=67c0c12d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0c12d",
  null
  
)

export default component.exports